import React from 'react';
import { formatHourAndMinuteDuration, formatTranslatedDuration } from "../../utils/dateTimeUtils";
import { ReactComponent as Clock } from '../../resources/images/clock.svg';
import styled, {useTheme} from 'styled-components';
import PropTypes from "prop-types";
import {Tag} from "../../resources/styles";

const ClockIcon = styled(Clock)`
    fill: ${props => props.theme.buttonBackground || '#6B207D'};
    stroke: ${props => props.theme.buttonBackground || '#6B207D'};
`;

const ExcursionDuration = ({duration, publishedDuration, reduceIcon}, context) => {
        const theme = useTheme();

        if(!duration && !publishedDuration){
            return null;
        }

        return (
            <div className="flex items-center">
                <Tag reduceIcon={reduceIcon} >
                    <ClockIcon/>
                </Tag>
                <span className="text-grey-darker">
                    { publishedDuration ? publishedDuration :
                        theme.useHourAndMinuteDuration ? formatHourAndMinuteDuration(duration) :
                            formatTranslatedDuration(duration, context.t('hour'), context.t('hours'))
                    }
                </span>
            </div>
        )
}

ExcursionDuration.contextTypes = {
    t: PropTypes.func.isRequired
}

export default ExcursionDuration;